import anyConst from './anySpecialHome'
import takeConst from './takeSpecialHome'

const emptyDefaultConstants = {
  defaultCourseIds: [],
  defaultRecommendedCourseIds: [],
  defaultNewCourseIds: [],
  defaultTopSaleCourseIds: [],
  defaultSpecialCourseId: 0,
  defaultSpecialStartDate: 0,
  defaultSpecialCourseIdSecond: 0,
  defaultSpecialStartDateSecond: 0,
  defaultSpecialCourseIdsInSubscription: [],
  defaultSpecialCourseIdsBundle: [],
  defaultSpecialCourseIdForClub: 0,
  defaultSpecialClubId: 0,
  defaultPaywallServiceId: 0
}

export function getSpecialHomeConst (project: 'any' | 'take') {
  if (project === 'take') {
    return takeConst
  }
  if (project === 'any') {
    return anyConst
  }

  return emptyDefaultConstants
}
